import {
  Chip,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Tooltip,
} from "@mui/material";
import ListHeader from "./ListHeader";
import { IExportTable, IExportRequest } from "../../interfaces/order";
import {
  downloadFromURL,
  mongoTimeStampToString,
  translateOrderStatus,
} from "../../utils/orders";
import { CARRIER_LABEL, MARKETPLACE, SLA_ALERT_LEVEL_CONFIG } from "../../utils/constants";

const allSlaLevelIds = Object.keys(SLA_ALERT_LEVEL_CONFIG);

const SlaAlertChips = ({ levels }: { levels?: string[] }) => {
  if (!levels?.length) return <>Todos</>;
  const isAll = allSlaLevelIds.every((id) => levels.includes(id));
  if (isAll) return <Chip label="Todos" size="small" sx={{ backgroundColor: "#9E9E9E", color: "#fff" }} />;
  return (
    <>
      {levels.map((level) => {
        const config = SLA_ALERT_LEVEL_CONFIG[level];
        return config ? (
          <Chip key={level} label={config.label} size="small" sx={{ backgroundColor: config.color, color: "#fff", mr: 0.5, mb: 0.5 }} />
        ) : null;
      })}
    </>
  );
};

const tableColumnsMarketplace = [
  { label: "Fecha de creación" },
  { label: "Desde" },
  { label: "Hasta" },
  { label: "Operador Logístico" },
  { label: "Merchant" },
  { label: "Estado" },
  { label: "Nivel de SLA" },
  { label: "Acciones" },
];

const tableColumns = [
  { label: "Fecha de creación" },
  { label: "Desde" },
  { label: "Hasta" },
  { label: "Operador Logístico" },
  { label: "Estado" },
  { label: "Nivel de SLA" },
  { label: "Acciones" },
];

const ExportOrdersTable = ({ requests, entity }: IExportTable) => (
  <TableContainer component={Paper} className="m-t-40 br-20 bg-light">
    <Table>
      <ListHeader
        columns={
          entity === MARKETPLACE ? tableColumnsMarketplace : tableColumns
        }
      />
      <TableBody>
        {requests?.map(
          (
            { path, createdAt, status, filter }: IExportRequest,
            index: number
          ) => (
            <TableRow key={index}>
              <TableCell className="p-l-20">
                {mongoTimeStampToString(createdAt, true)}
              </TableCell>
              <TableCell>
                {mongoTimeStampToString(filter?.from, true)}
              </TableCell>
              <TableCell>{mongoTimeStampToString(filter?.to, true)}</TableCell>
              <TableCell>
                {filter?.carrier_name
                  ? (CARRIER_LABEL[filter.carrier_name] || filter.carrier_name).toUpperCase()
                  : "Todos"}
              </TableCell>
              {entity === MARKETPLACE && (
                <TableCell>{filter?.merchant_name || "Todos"}</TableCell>
              )}
              <TableCell>
                {translateOrderStatus(filter?.status_filter) ||
                  "Todos los estados"}
              </TableCell>
              <TableCell>
                <SlaAlertChips levels={filter?.sla_alert_level} />
              </TableCell>
              <TableCell>
                {path ? (
                  <Tooltip arrow title="Descargar" placement="top">
                    <IconButton
                      size="small"
                      color="primary"
                      onClick={() => downloadFromURL(path)}
                    >
                      <span className="material-symbols-rounded">download</span>
                    </IconButton>
                  </Tooltip>
                ) : (
                  status
                )}
              </TableCell>
            </TableRow>
          )
        )}
      </TableBody>
    </Table>
  </TableContainer>
);

export default ExportOrdersTable;
